import { AxiosInstance } from "axios";

export const userRequests = (baseUrl: string, customAxios: AxiosInstance) => ({
    getProfile: async (userId: number) => {
        return customAxios.get(`${baseUrl}/profile?id=${userId}`);
    },
});
